var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { CycleDots_ } from '../../../../areas/CycleBar/Dot/CycleDots_';
let AbfragerCycleEndMenuPart = class AbfragerCycleEndMenuPart extends React.PureComponent {
    get app() {
        return this.props.question.context.app;
    }
    render() {
        return (React.createElement("div", { "data-aspect": "CycleMenuPart", style: { flex: '1 1 auto', display: 'flex', flexDirection: 'column' } },
            React.createElement("div", { style: { textAlign: 'center' } },
                React.createElement("h4", { className: "text-danger", style: { marginTop: 60, textAlign: 'center' } }, "Deine Antworten"),
                React.createElement("div", { style: {
                        height: 20,
                        display: 'flex',
                        alignItems: 'stretch',
                        marginRight: 15,
                        marginLeft: 15,
                        marginTop: 20,
                    } },
                    React.createElement(CycleDots_, { app: this.app }))),
            React.createElement("div", { style: { textAlign: 'center' } },
                React.createElement("h2", { className: "text-danger", style: { fontWeight: 'bold', marginTop: 60 } }, this.app.funnel.numberOfRemainingQuestions),
                React.createElement("h4", { className: "text-danger" }, "Fragen verbleiben"),
                React.createElement("div", { style: { marginTop: 70 } }, this.app.funnel.numberOfRemainingQuestions > 0 && (React.createElement("h3", null,
                    React.createElement("a", { href: "#", onClick: () => this.app.directive.directiveStartNewCycle.startNewCycleByReload() }, "Na, dann weiter!")))))));
    }
};
AbfragerCycleEndMenuPart = __decorate([
    observer
], AbfragerCycleEndMenuPart);
export { AbfragerCycleEndMenuPart };
